@value tablet from "@shared/styles/breakpoints.module.css";

.root {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
  align-items: start;
  gap: var(--space-project-gap);
  min-width: 0;

  @media (max-width: tablet) {
    grid-template-columns: 1fr;
  }
}

.figure {
  margin: 0;
  min-width: 0;
}

.photoButton {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 4 / 3;
  padding: 0;
  border: 0;
  border-radius: var(--radius-medium);
  overflow: hidden;
  font: inherit;
  text-align: left;
  background: var(--color-card);
  cursor: zoom-in;

  &:focus-visible span {
    opacity: 1;
    background: var(--color-primary);
    color: var(--color-cta-text-color);
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover span {
      opacity: 1;
      background: var(--color-primary);
      color: var(--color-cta-text-color);
    }
  }
}

/* Геометрия рамки имеет приоритет над базовыми размерами Picture. */
.photoButton .image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photoAction {
  position: absolute;
  right: var(--space-12);
  bottom: var(--space-12);
  display: inline-flex;
  align-items: center;
  gap: var(--space-8);
  padding: var(--space-10) var(--space-12);
  border-radius: var(--radius-control);
  min-height: var(--layout-control-height);
  background: var(--color-card);
  color: var(--color-text);
  font-size: var(--type-caption);
  font-weight: 600;
  opacity: 0;
  transition:
    opacity var(--motion-fast),
    background var(--motion-fast),
    color var(--motion-fast);
}

.photoButton[aria-busy="true"] .photoAction {
  opacity: 1;
}

@media (hover: none) {
  .photoAction {
    opacity: 1;
  }
}

.credit {
  padding-top: var(--space-8);
  font-size: var(--type-caption);
  line-height: 1.5;
  color: var(--color-text-muted);

  a {
    color: inherit;
    text-underline-offset: var(--space-3);

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: var(--color-primary);
      }
    }
  }
}

.body {
  min-width: 0;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--space-8);
  color: var(--color-text-muted);
  font-size: var(--type-caption);
  font-weight: 600;
}

.title {
  margin: var(--space-18) 0 var(--space-12);
  font-family: var(--font-heading);
  font-size: var(--type-project);
  font-weight: 600;
  line-height: 1.2;
  color: var(--color-text);
  text-wrap: pretty;
  text-transform: none;
  letter-spacing: normal;
}

.location {
  display: flex;
  align-items: baseline;
  gap: var(--space-6);
  font-size: var(--type-caption);
  color: var(--color-text-muted);

  svg {
    flex-shrink: 0;
    align-self: center;
  }
}

.description {
  margin-top: var(--space-20);
  font-size: var(--type-body);
  line-height: 1.65;
  color: var(--color-text);
}

.equipment {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-8) var(--space-16);
  margin: var(--space-20) 0 var(--space-12);
  padding: 0;
  list-style: none;
  color: var(--color-text-muted);
  font-size: var(--type-caption);
  line-height: 1.5;
}

.sources {
  summary {
    display: inline-flex;
    align-items: center;
    gap: var(--space-12);
    min-height: var(--space-44);
    padding: var(--space-8) 0;
    color: var(--color-primary);
    font-size: var(--type-caption);
    list-style: none;
    cursor: pointer;

    &::-webkit-details-marker {
      display: none;
    }
    svg {
      transition: transform var(--motion-fast);
    }
  }

  &[open] summary svg {
    transform: rotate(180deg);
  }
}

.sourceList {
  margin: 0;
  padding: 0;
  list-style: none;
  a {
    display: inline-block;
    padding: var(--space-8) 0;
    color: var(--color-primary);
    font-size: var(--type-caption);
    line-height: 1.5;
    text-underline-offset: var(--space-4);
    overflow-wrap: anywhere;
  }
}

.contract {
  margin-top: var(--space-12);
  color: var(--color-text-muted);
  font-size: var(--type-caption);
  line-height: 1.6;
  overflow-wrap: anywhere;
  a {
    color: inherit;
  }
}
